import { NgClass, NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ItemsHelperService } from 'src/app/services/helpers/items-helper.service';

@Component({
  selector: 'app-themes',
  standalone: true,
  imports: [NgIf, NgForOf, NgClass, TranslateModule],
  templateUrl: './themes.component.html',
})
export class ThemesComponent {
  @Input() themes: any[] = [];
  @Output() closemodal = new EventEmitter<boolean>();
  @Input() selectedTheme = 0;

  constructor(private itemsHelperService: ItemsHelperService) { }

  selectTheme(themeId: number) {
    this.selectedTheme = themeId;
    this.itemsHelperService.selectTheme(themeId);
  }
}
